// biome-ignore lint/style/noRestrictedGlobals: encapsulation
export const { pow } = Math;
